import catalogContexts from "@utils/constants/catalogContexts";
import findOrderByOptions from "@utils/catalog-filters/findOrderByOptions";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;
const allowedSortBy = findOrderByOptions().map((option) => option.label);

export default function computeSortBy(context, sortBy) {
  const whitelistedSortBy = allowedSortBy.includes(sortBy) ? sortBy : null;

  switch (context) {
    case catalogContexts.swap:
      if (!whitelistedSortBy || whitelistedSortBy === "our_choice") return mainIndex;

      return mainIndex.replace("principal", whitelistedSortBy);
    case catalogContexts.wishlist:
    case catalogContexts.userlist:
      if (!whitelistedSortBy || whitelistedSortBy === "newest")
        return mainIndex.replace("principal", "newest");

      return mainIndex;
    case catalogContexts.sales:
      if (!whitelistedSortBy || whitelistedSortBy === "our_choice")
        return mainIndex.replace("principal", "sale");

      return mainIndex.replace("principal", whitelistedSortBy);
    default:
      return mainIndex;
  }
}
